/**
 * Admin layout wrapper — sidebar + content area (mirrors DashboardLayout).
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';

export default function AdminLayout() {
  return (
    <div className="dash-layout">
      <AdminSidebar />
      <main className="dash-content">
        <Outlet />
      </main>
    </div>
  );
}
